import styled from "styled-components";
import { useConfig } from "../../hooks";

const Styled = styled.div`
  position: absolute;
  top: 82%;
  left: 20%;
  right: 20%;
  bottom: 17.5%;
  width: 60%;
  max-width: 350px;
  margin: auto;
  border-width: 0px;
  z-index: 2;

  * {
    border-radius: 0.2em;
  }

  .full,
  .empty {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  .full {
    right: 100%;
    z-index: 3;
    border-radius: 0;
    box-shadow: 0px 0px 15px 2px ${({ config }: any) => config.full.backgroundColor};
    background-color: ${({ config }: any) => config.full.backgroundColor};
  }

  .empty {
    width: 100%;
    z-index: 2;
    outline-style: solid;
    outline-width: 1px;
    outline-color: ${({ config }: any) => config.empty.outlineColor};
    background-color: ${({ config }: any) => config.empty.backgroundColor};
  }

  ${(props: any) => props.config.style || ""}
` as any;

const LoadingBar: React.FC<{ progress: number }> = ({ progress }) => {
  const { loadingScreen: config } = useConfig();
  if (progress === 100) return null;

  const width = (progress ?? 0) + "%";

  return (
    <Styled className="loading-bar" config={config.progress}>
      <div className="full" style={{ width }}></div>
      <div className="empty"></div>
    </Styled>
  );
};

export default LoadingBar;
